import { Box, TextField } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import React, { useCallback, useState } from 'react';
import { dateFormat } from '../../../../helpers/dateFormat';
import { LayoutRegister } from '../../../../layouts';
import { blockerService, finishRequest, IBlockerView } from '../../../../services';
import { Api } from '../../../../services/api/axios-config';
import { setCsrfRequestToken } from '../../../../services/api/axios-config/interceptors';
import { Button } from '../../../MUI/button/Button';
import { DeleteConfirmationDialog } from '../../deleteConfirmation/DeleteConfirmationDialog';

interface IBlockerDetailsProps {
  blocker: IBlockerView;
  refetch: () => any;
  refetchBlockers: () => any;
  onClose: () => any;
}

export const BlockerDetails: React.FC<IBlockerDetailsProps> = ({ blocker, refetch, refetchBlockers, onClose }) => {
  const [openDialogRemove, setOpenDialogRemove] = useState(false);

  const { mutate: remove, isLoading: isLoadingRemove } = useMutation(async (id: number) => {
    try {
      const tokenRes = await Api.get('/auth/antiforgery-token');
      if (tokenRes.data) setCsrfRequestToken(tokenRes.data as string);
    } catch {
      // best-effort
    }
    return blockerService.remove(id);
  }, {
    onSuccess: () => finishRequest('Blocker removido', 'success', () => {
      refetch();
      refetchBlockers();
      setOpenDialogRemove(false);
      onClose();
    }),
    onError: (error: any) => finishRequest(String(error), 'error'),
  });

  const handleConfirmRemove = useCallback(async () => {
    remove(blocker.id);
  }, []);

  return (
    <LayoutRegister header='Blocker' isLoading={false} hideSaveButton>
      <Box display='flex' flexDirection='column' gap={2}>
        <TextField
          label='Motivo'
          value={blocker.reason}
          disabled
        />

        <TextField
          label='Data de início'
          value={dateFormat(blocker.startDate, 'LLL')}
          disabled
        />

        <TextField
          label='Data de fim'
          value={dateFormat(blocker.endDate, 'LLL')}
          disabled
        />

        <TextField
          label='Hora de inicio'
          value={blocker.startTime}
          disabled
        />

        <TextField
          label='Hora de fim'
          value={blocker.endTime}
          disabled
        />

        <Button label='Remover' onClick={() => setOpenDialogRemove(true)} />
      </Box>

      <DeleteConfirmationDialog
        isLoading={isLoadingRemove}
        onClose={() => setOpenDialogRemove(false)}
        onConfirm={handleConfirmRemove}
        open={openDialogRemove}
        label='Tem certeza que deseja deletar este blocker e todas suas recorrências passadas e futuras?'
      />
    </LayoutRegister>
  );
};